import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'border-corner-square', 'BorderCornerSquare', [["path",{"d":"M4 20v-15a1 1 0 0 1 1 -1h15","key":"svg-0"}]]);